
import { defineComponent } from "vue";
import { ITuitionDiscountsModel } from "@/interfaces/modules";
import TuitionDiscountsService from "@/api/Collection/TuitionDiscountsService";
import store from "@/store";

export default defineComponent({
  name: "TuitionDiscountsContent",
  data() {
    return {
      form: {
        loading: true,
        dialog: false,
        valid: false,
        record: {} as ITuitionDiscountsModel,
        rules: {
          required: [(v: any) => !!v || "Este campo es requerido"],
        },
      },
      table: {
        filters: { search: "" },
        currentPage: 1,
        loading: false,
        headers: [
          { key: "Code", label: "Código", sortable: true },
          { key: "Description", label: "Descripción", sortable: true },
          { key: "Type", label: "Tipo", sortable: true },
          { key: "Value", label: "Valor (%)", sortable: true },
          { key: "IsActive", label: "Activo", sortable: true },
          { key: "CreatedByFormat", label: "Creación", sortable: true },
          { key: "ModifiedByFormat", label: "Última modificación", sortable: true },
          { key: "action", label: "Acciones", sortable: false },
        ],
        records: [] as ITuitionDiscountsModel[],
        rowsPerPage: 10,
      } as any,
    };
  },
  computed: {
    filteredItems(): any {
      const q = this.table.filters.search?.toLowerCase() || "";
      return q
        ? this.table.records.filter((item: ITuitionDiscountsModel) =>
            [item.Code, item.Description, item.Type, item.Value]
              .filter(Boolean)
              .some((v) => String(v).toLowerCase().includes(q))
          )
        : this.table.records;
    },
    rows(): number {
      return this.table.records?.length || 0;
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    async load() {
      this.table.loading = true;
      this.table.records = await TuitionDiscountsService.GetDiscounts();
      this.table.loading = false;
    },
    async edit(data: ITuitionDiscountsModel) {
      this.form.record = await TuitionDiscountsService.GetDiscountById({ Id: data.Id } as any);
      this.form.dialog = true;
    },
    openModal() {
      this.form.record = { IsActive: true } as ITuitionDiscountsModel;
      this.form.dialog = true;
    },
    async handleSubmit(event: Event) {
      event.preventDefault();
      this.form.dialog = false;
      await TuitionDiscountsService.PostDiscount(this.form.record);
      store.dispatch("core/popupDialog", {
        text: "Registro completado con éxito.",
        type: "success",
        showCancelButton: false,
      });
      this.load();
    },
  },
});
